


















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Store types
import { ToolSpace, SpacesGetter } from '@/store/store.types';

/**
 *  Holding the actions of a space, including the toggle and remove.
 */
@Component
export default class SpaceActions extends Vue {

    @Prop({ type: Object, required: true })
    private toolSpace!: ToolSpace;

    @Prop({ type: String, required: true })
    private toggleTitle!: string;

    /**
     *  Used to get the fact if there is only one space
     *  left: hiding the remove action and disabling
     *  users from removing the last space.
     */
    private get singleSpace(): boolean {

        return this.$store.getters[SpacesGetter.COUNT_ADDED] === 1;

    }

}
